// Table of Contents Functionality
(function () {
  'use strict';

  class TableOfContents {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.tocContainer = document.getElementById(`tableOfContents-${sectionId}`);
      this.init();
    }

    init() {
      if (!this.tocContainer) {
        console.log('TOC: Container not found for section', this.sectionId);
        return;
      }

      console.log('TOC: Initializing for section', this.sectionId);
      this.generateTOC();
      this.bindEvents();
    }

    generateTOC() {
      // Try to find the article content area with flexible class matching
      let articleMain = document.querySelector('.rte.cf.spaced-row.cc-animate-init.cc-animate-in');

      // Fallback: if animation classes are missing, try with just the core classes
      if (!articleMain) {
        articleMain = document.querySelector('.rte.cf.spaced-row');
      }

      // Final fallback: just look for the main .rte class
      if (!articleMain) {
        articleMain = document.querySelector('.rte');
      }

      console.log('TOC: Article main found:', !!articleMain);

      if (!articleMain) {
        this.tocContainer.innerHTML = '<p class="no-headings">Article main container not found.</p>';
        return;
      }

      // Get the section element to access settings
      const sectionElement = document.querySelector(`[data-toc-section="${this.sectionId}"]`);
      if (!sectionElement) {
        console.log('TOC: Section element not found for', this.sectionId);
        return;
      }

      // Check which heading levels are enabled based on section settings
      const headingSelectors = [];

      // Check if H2 is enabled (default: true)
      if (sectionElement.dataset.tocIncludeH2 !== 'false') {
        headingSelectors.push('h2');
      }

      // Check if H3 is enabled (default: true)
      if (sectionElement.dataset.tocIncludeH3 !== 'false') {
        headingSelectors.push('h3');
      }

      // Check if H4 is enabled (default: false)
      if (sectionElement.dataset.tocIncludeH4 === 'true') {
        headingSelectors.push('h4');
      }

      console.log('TOC: Enabled heading levels:', headingSelectors);

      if (headingSelectors.length === 0) {
        this.tocContainer.innerHTML =
          '<p class="no-headings">No heading levels are enabled for the table of contents.</p>';
        return;
      }

      const headings = articleMain.querySelectorAll(headingSelectors.join(', '));
      console.log('TOC: Found headings in article main:', headings.length);

      if (headings.length === 0) {
        this.tocContainer.innerHTML = '<p class="no-headings">No headings found in the article main content.</p>';
        return;
      }

      this.createTOCList(headings);
    }

    createTOCList(headings) {
      // Clear existing content
      this.tocContainer.innerHTML = '';

      const tocList = document.createElement('ul');
      tocList.className = 'toc-list';

      headings.forEach((heading, index) => {
        const id = `heading-${this.sectionId}-${index}`;
        heading.id = id;

        const listItem = document.createElement('li');
        const link = document.createElement('a');

        link.href = `#${id}`;
        link.textContent = heading.textContent;
        link.className = `toc-link toc-${heading.tagName.toLowerCase()}`;

        listItem.appendChild(link);
        tocList.appendChild(listItem);
      });

      this.tocContainer.appendChild(tocList);
      console.log('TOC: Generated successfully with', headings.length, 'headings');
    }

    bindEvents() {
      // Smooth scrolling for TOC links
      this.tocContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('toc-link')) {
          e.preventDefault();
          const target = document.querySelector(e.target.getAttribute('href'));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }
  }

  // Global function to initialize TOC (called from section)
  window.initTableOfContents = function (sectionId) {
    console.log('TOC: Initializing from global function for section', sectionId);
    new TableOfContents(sectionId);
  };

  // Also auto-initialize any existing TOC sections
  function autoInitTOC() {
    const tocSections = document.querySelectorAll('[data-toc-section]');
    console.log('TOC: Auto-initializing', tocSections.length, 'sections');

    tocSections.forEach((section) => {
      const sectionId = section.dataset.tocSection;
      if (sectionId) {
        new TableOfContents(sectionId);
      }
    });
  }

  // Initialize when script loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitTOC);
  } else {
    autoInitTOC();
  }

  // Also try when window loads
  window.addEventListener('load', autoInitTOC);
})();
